import React, { Fragment, useEffect, useRef } from 'react';

import MainFooter from './MainFooter';
import AlternativeFooter from './AlternativeFooter';
import { IDefaultLayout } from '@/interfaces/Layouts';
import { TermsAndPrivacy } from '@/components/TermsAndPrivacy';
import arrowUp from '@/static/images/arrow-up.svg';

import './styles.scss';

interface FooterProps extends IDefaultLayout {}

const Footer = ({ pageContext, display }: FooterProps) => {
  const { appData, pathLang } = pageContext;
  const { locale } = appData;
  const documentRef = useRef<Document | null>(null);

  const HEIGHT_TO_SHOW_SCROLL_TO_TOP_BUTTON = 900;

  useEffect(() => {
    documentRef.current = document;
    const bodyVariable = '--scroll-top-height';
    const scrollToTopButton = document.querySelector('.scroll-to-top');

    window.addEventListener('scroll', (e) => {
      if (window.scrollY >= HEIGHT_TO_SHOW_SCROLL_TO_TOP_BUTTON) {
        scrollToTopButton?.classList.add('showScrollToTop');
        documentRef.current?.body.style.setProperty(bodyVariable, `40px`);
      } else {
        scrollToTopButton?.classList.remove('showScrollToTop');
        documentRef.current?.body.style.setProperty(bodyVariable, `0px`);
      }
    });
  }, []);

  return (
    <Fragment>
      <footer className="footer">
        {display === 'default' ? (
          <MainFooter pageContext={pageContext} />
        ) : (
          <AlternativeFooter pageContext={pageContext} />
        )}
      </footer>
      <TermsAndPrivacy footerLocale={locale.footer} pathLang={pathLang} />

      <button
        className="scroll-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Voltar ao Topo"
      >
        <img src={arrowUp} alt="" />
      </button>
    </Fragment>
  );
};

export default Footer;
